var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAjustes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.59 36.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-100 {\r\n        stroke-width: .35px;\r\n      }\r\n\r\n      .cls-100, .cls-200, .cls-300, .cls-400 {\r\n        fill: none;\r\n        stroke: currentcolor;\r\n      }\r\n\r\n      .cls-100, .cls-200, .cls-400 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-300 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-400 {\r\n        stroke-width: .85px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-300",
    cx: 12.96,
    cy: 9.13,
    rx: 6.14,
    ry: 7.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M16.87,19.18h-7.82c-4.72,0-8.55,3.83-8.55,8.55v6.47c0,.8.65,1.45,1.45,1.45h22.21c.8,0,1.45-.65,1.45-1.45v-3.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-200",
    x1: 19.84,
    y1: 28.66,
    x2: 19.84,
    y2: 35.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-200",
    x1: 5.8,
    y1: 28.66,
    x2: 5.8,
    y2: 35.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M4.9,6.21h17.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-400",
    x1: 12.96,
    y1: 0.42,
    x2: 12.96,
    y2: 3.23
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-300",
    cx: 27.1,
    cy: 18.88,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "g235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path243",
    className: "cls-100",
    d: "M26.53,20.78c0,.73-.59,1.33-1.33,1.33s-1.33-.59-1.33-1.33.59-1.33,1.33-1.33,1.33.59,1.33,1.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path247",
    className: "cls-100",
    d: "M29.14,21.35c.03-.19.05-.38.05-.57s-.02-.38-.05-.57l-.8-.15c-.08-.35-.22-.68-.41-.98l.46-.67c-.11-.15-.23-.3-.37-.44-.14-.14-.28-.26-.44-.37l-.67.46c-.3-.19-.63-.33-.98-.41l-.15-.8c-.19-.03-.38-.05-.57-.05s-.38.02-.57.05l-.15.8c-.35.08-.68.22-.98.41l-.67-.46c-.15.11-.3.23-.44.37-.14.14-.26.28-.37.44l.46.67c-.19.3-.33.63-.41.98l-.8.15c-.03.19-.05.38-.05.57s.02.38.05.57l.8.15c.08.35.22.68.41.98l-.46.67c.11.15.23.3.37.44.14.14.28.26.44.37l.67-.46c.3.19.63.33.98.41l.15.8c.19.03.38.05.57.05s.38-.02.57-.05l.15-.8c.35-.08.68-.22.98-.41l.67.46c.15-.11.3-.23.44-.37.14-.14.26-.28.37-.44l-.46-.67c.19-.3.33-.63.41-.98l.8-.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path251",
    className: "cls-100",
    d: "M26.52,18.93c-.89-.63-2.13-.55-2.92.24-.8.8-.88,2.04-.24,2.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path255",
    className: "cls-100",
    d: "M23.89,22.63c.89.63,2.13.55,2.92-.24.8-.8.88-2.04.24-2.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path259",
    className: "cls-100",
    d: "M29.09,14.9c0-.11-.01-.21-.03-.31l.24-.2c-.04-.15-.1-.3-.18-.44s-.18-.27-.29-.38l-.29.11c-.15-.13-.33-.24-.53-.31l-.05-.31c-.15-.04-.31-.06-.48-.06s-.32.02-.48.06l-.05.31c-.2.07-.38.17-.53.31l-.29-.11c-.11.11-.21.24-.29.38-.08.14-.14.29-.18.44l.24.2c-.02.1-.03.2-.03.31s.01.21.03.31l-.24.2c.04.15.1.3.18.44.08.14.18.27.29.38l.29-.11c.15.13.33.24.53.31l.05.31c.15.04.31.06.48.06s.32-.02.48-.06l.05-.31c.2-.07.38-.17.53-.31l.29.11c.11-.11.21-.24.29-.38.08-.14.14-.29.18-.44l-.24-.2c.02-.1.03-.2.03-.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path263",
    className: "cls-100",
    d: "M28.21,14.71c.02.06.02.12.02.19,0,.42-.34.76-.76.76s-.76-.34-.76-.76.34-.76.76-.76c.07,0,.13,0,.19.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path267",
    className: "cls-100",
    d: "M32.22,19.26c.07-.07.14-.15.2-.24l.31.03c.08-.14.14-.28.18-.44.04-.16.06-.32.06-.48l-.29-.13c-.01-.2-.07-.41-.16-.59l.19-.25c-.08-.14-.18-.26-.29-.38-.12-.12-.25-.21-.38-.29l-.25.19c-.19-.09-.39-.14-.59-.16l-.13-.29c-.16,0-.32.02-.48.06-.16.04-.31.11-.44.18l.03.31c-.08.06-.16.12-.24.2-.07.07-.14.15-.2.24l-.31-.03c-.08.14-.14.28-.18.44-.04.16-.06.32-.06.48l.29.13c.01.2.07.41.16.59l-.19.25c.08.14.18.26.29.38.12.12.25.21.38.29l.25-.19c.19.09.39.14.59.16l.13.29c.16,0,.32-.02.48-.06.16-.04.31-.11.44-.18l-.03-.31c.08-.06.16-.12.24-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path271",
    className: "cls-100",
    d: "M31.81,17.94c.02.06.02.12.02.19,0,.42-.34.76-.76.76s-.76-.34-.76-.76.34-.76.76-.76c.07,0,.13,0,.19.02"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjustes);
export default __webpack_public_path__ + "static/media/Ajustes.87984f5ea7b26125b8fb0e2b2ec2ecf6.svg";
export { ForwardRef as ReactComponent };